import { gpsDisabled } from "assets/images";
import React, { useState, useEffect } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import {
    FaRegCalendarAlt,
    FaRegClock,
    FaRegUser,
    FaChevronCircleLeft,
} from "react-icons/fa";
import "./PersonalizedVideo.scss";
import CommonModal from "components/modal-box/CommonModal";
import {
    Navigate,
    useLocation,
    useNavigate,
    useParams,
} from "react-router-dom";
import { toast } from "react-hot-toast";
import { personalizedUserLectureDetail, relatedPersonalizedLectureListView, userLectureDetail, userRelatedLectures } from "services/lecture";
import LectureDetailSkeleton from "components/skeleton/LectureDetailSkeleton";
import {
    charLimit,
    lectureAccess,
    lectureIsExpired,
    lectureIsStarted,
    momentDateFormat,
} from "config/utils";
import moment from "moment";
import YoutubeVideo from "components/video-player/YoutubeVideo";
import ApexVideo from "components/video-player/ApexLecture"
import { getUserIp } from "services/third-party";
import {
    errorResponse,
    failResponse,
    normalDecryptData,
    normalEncryptData,
} from "config/config";
import VideoJsCipherPlayer from "components/video-player/VideoJsCipherPlayer";
import { useCourse } from "context/context";
import LiveLectureDetailSkeleton from "components/skeleton/LiveLectureDetailSkeleton";
import LectureNotFound from "components/Not-Found/LectureNotFound";
import { getSignedUrl } from "services/master";
import { PlayApexLecture } from "services/lecture";


function PersonalizedLectureVideo() {
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lectureDetail, setLectureDetail] = useState({});
    const [otp, setOtp] = useState("");
    const [playbackInfo, setPlaybackInfo] = useState("");
    const [lecture, setLecture] = useState({});
    const [relatedLectures, setRelatedLectures] = useState([]);
    const [, setTotal] = useState(0);
    const [accessStatus, setAccessStatus] = useState(true);
    const [locationStatus, setLocationStatus] = useState(true);
    const { lectureId } = useParams();
    const { course } = useCourse();
    const location = useLocation();
    const navigate = useNavigate();
    const mainLectureId = normalDecryptData(lectureId, "route")?.split(",");
    const [videoUrl, setVideoUrl] = useState("");


    const [submitLoading, setSubmitLoading] = useState(false);
    const [relatedLecturesLoading, setRelatedLecturesLoading] = useState(false);


   const navigationHandler = (id, startDate, endDate, time) => {
   
       navigate(`/dashboard/personalized-lecture/detail/${normalEncryptData(id, "route")}`)
   
   
     };



    const notesDownloader = async (url) => {
        setSubmitLoading(true);
        window.open(await getSignedUrl({ pdfUrl: url }));
        setSubmitLoading(false);
    };

    // ----------------------- getting lecture detail data -------------------------//
    React.useLayoutEffect(() => {
        // get lecture series detail
        const getLectureDetails = async (lat, long) => {
            try {
                setLoading(true);
                const { data: ip } = await getUserIp();
                const res = await personalizedUserLectureDetail({
                    lecture_id: mainLectureId[0],
                    latitude: lat,
                    longitude: long,
                    ip: ip.ip,
                });

                if (res.code === 200) {
                    setLectureDetail(res.data.lectureDetail || {});
                    setLecture(res.data.lectureDetail || {});
                    if (!res.data.lectureDetail?.IsYoutube && !res.data.lectureDetail?.IsApex) {
                        setOtp(res.data.vdocipherOtp.otp);
                        setPlaybackInfo(res.data.vdocipherOtp.playbackInfo);
                    }

                    setLoading(false);
                } else if (res.code === 101) {
                    setAccessStatus(false);
                    failResponse(res);
                } else {
                    failResponse(res);
                    setLoading(false);
                }
            } catch (err) {
                errorResponse(err);
                setLoading(false);
            }
        };

        getLectureDetails()
        // get related lectures
        const getRelatedLectureDetails = async () => {
            try {
                // Show loader
                setRelatedLecturesLoading(true);

                // Fetch related lectures
                const { data: ip } = await getUserIp();
                const res = await relatedPersonalizedLectureListView({
                    lecture_id: mainLectureId[0],
                    courseId: course.courseId,
                    ip: ip.ip,
                });

                if (res.code === 200) {
                    setRelatedLectures(res.data.relatedLectures || []);
                    setTotal(res.data.relatedLectures.count || 0);
                } else {
                    failResponse(res);
                }
            } catch (err) {
                errorResponse(err);
            } finally {
                // Hide loader
                setRelatedLecturesLoading(false);
            }
        };

        getRelatedLectureDetails();


        // eslint-disable-next-line
    }, [lectureId]);



    useEffect(() => {
        const fetchVideoUrl = async () => {
            try {
                const res = await PlayApexLecture({
                    lecture_id: lectureId,
                });

                if (res.code === 200) {
                    setVideoUrl(res.data);
                } else {
                }
            } catch (err) {
            } finally {
                setLoading(false);
            }
        };

        if (lecture.IsApex) {
            fetchVideoUrl();
        }
    }, [lecture.IsApex]);
    const handleNavigate = () => {
        navigate(`/dashboard/personalized-lectures`);
    };
    return (
        <>
            {accessStatus ? (
                <>

                    <section
                        className={`PersonalizedLectureVideo ${+mainLectureId[1] === 1 && "liveLecture_video"
                            }`}
                            style={{padding:"10px"}}
                    >
                        <div className="container">
                            <div className="back_button">
                                <button onClick={handleNavigate}>
                                    <FaChevronCircleLeft />
                                </button>
                                {/* <button onClick={() => navigate(-1)}>
                    <FaChevronCircleLeft />
                  </button> */}
                            </div>
                        </div>
                        <div className="container">
                            {/* loading component */}
                            {loading &&
                                (+mainLectureId[1] !== 1 ? (
                                    <LectureDetailSkeleton />
                                ) : (
                                    <LiveLectureDetailSkeleton />
                                ))}
                            {/* related lectures loading component */}
                            {relatedLecturesLoading && (
                                <div className="relatedLecturesLoader">
                                    {/* Add your loader component here */}
                                </div>
                            )}
                            {/* main component */}
                            {!loading && !relatedLecturesLoading && (
                                <>
                                    {+mainLectureId[1] !== 1 && (
                                        <div className="courseList">
                                            <ul>
                                                {/* related lecture not found */}
                                                {relatedLectures?.length <= 0 && (
                                                    <li>No Related Lectures Available</li>
                                                )}

                                                {/* related lecture listing */}
                                                {relatedLectures &&
                                                    relatedLectures.map((data, i) => (
                                                        <li
                                                            key={i}
                                                            role="button"
                                                            className={`lecture-card ${data.ongoing ? "disabled ongoing" : ""}`}
                                                            onClick={() => {
                                                                if (!data.ongoing) {
                                                                    navigationHandler(data.LectureID);
                                                                }
                                                            }}
                                                        >
                                                            <h5>{charLimit(data.LectureTitle, 30)}</h5>

                                                            <p>
                                                                <span>
                                                                    <FaRegUser />
                                                                    {data.TeacherName || "N/A"}
                                                                </span>

                                                                <span className="red">
                                                                    <FaRegCalendarAlt />
                                                                    {momentDateFormat(
                                                                        data.speciallectures?.[0]?.expiredate
                                                                    )}
                                                                </span>
                                                            </p>

                                                            {data.ongoing && (
                                                                <span className="upcomingTag">Active Video</span>
                                                            )}
                                                        </li>
                                                    ))}

                                            </ul>
                                        </div>
                                    )}
                                    <div className="course_video">
                                        <div className="video_wrap">
                                            {/* vdo cipher video player */}
                                            {!lecture.IsYoutube && !lecture.IsApex && (
                                                <div className="vdocipher_video">
                                                    {/* display video if otp & playbackInfo is available */}
                                                    {otp && playbackInfo && (
                                                        <>
                                                            <VideoJsCipherPlayer
                                                                otp={otp}
                                                                playbackInfo={playbackInfo}
                                                                isTimeSpentApplicable={
                                                                    !!lectureDetail?.istimespent
                                                                }
                                                                lastSeekBar={lectureDetail?.lastPlay}
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            )}

                                            {/* youtube video player */}
                                            {lecture.IsYoutube && (
                                                <div className="youtube_video">
                                                    <YoutubeVideo
                                                        src={lecture.VideoFile}
                                                        width="100%"
                                                        height="400"
                                                    />
                                                </div>
                                            )}

                                            {/* youtube video player */}
                                            {lecture.IsApex && (
                                                <div className="youtube_video">
                                                    <ApexVideo
                                                        src={videoUrl}
                                                        width="100%"
                                                        height="400"
                                                    />
                                                </div>
                                            )}


                                            <div className="about_video">
                                                <div className="content">
                                                    <h5>{lectureDetail.lecturetitle}</h5>
                                                    <ul>
                                                        <li>
                                                            <FaRegUser />
                                                            {lectureDetail.TeacherName}
                                                        </li>
                                                        {/* <li>
                                                            <FaRegClock /> {lecture.Duration} mins
                                                        </li>
                                                        <li>
                                                            <FaRegCalendarAlt />{" "}
                                                            {momentDateFormat(lectureDetail.dateScheduled)}
                                                        </li> */}
                                                        <li className="red">
                                                            <FaRegCalendarAlt />
                                                            {momentDateFormat(lectureDetail.expiredate)}
                                                        </li>
                                                    </ul>
                                                </div>
                                                {/* <div className="button_wrap">
                                                    <button
                                                        type="button"
                                                        className="dashboard_button fill"
                                                        onClick={() => notesDownloader(lecture.Notes)}
                                                        disabled={!lecture.Notes || submitLoading}
                                                    >
                                                        <AiOutlineDownload />
                                                        Download notes
                                                    </button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <CommonModal
                            modalShow={modalShow}
                            handleClose={() => setModalShow(false)}
                            title={"Modal heading"}
                        ></CommonModal>
                    </section>

                </>
            ) : (
                <section className="PersonalizedLectureVideo liveLecture_video spacing">
                    <div className="container">
                        <div className="back_button">
                            <button onClick={() => navigate(-1)}>
                                <FaChevronCircleLeft />
                            </button>
                        </div>
                    </div>
                    <div className="container">
                        <div className="course_video">
                            <div className="video_wrap">
                                <LectureNotFound
                                    note={
                                        locationStatus
                                            ? `This lecture is not allowed to play at this location`
                                            : `location is required, please allow location`
                                    }
                                    image={gpsDisabled}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}

export default PersonalizedLectureVideo;
